import i18nMixin from '../i18nMixin';
import * as cadastreReportActions from '../../actions/cadastreReport';
import authMixin from '../authMixin';

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
}

export function init(tag) {
  tag.mixin(authMixin);
  tag.mixin(i18nMixin);

  tag.formSubmit = function (event: Event) {
    event.preventDefault();
    const cadastreKey = tag.refs.cadastreKeyInput.value.trim();
    const formattedKey = replaceAll(cadastreKey, '/', '-');

    cadastreReportActions.requestCadastreLookup(formattedKey);
    tag.update();
  };
}
